import { useEffect, useState } from "react";
import { CONSULTATION_ICONS } from "../../cufront-assets/icons/Icons";
import "../css/ConsultationLeftBar.css";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { BsFileEarmarkMedical } from "react-icons/bs";
// import { Popup } from "semantic-ui-react";
import { useMediaQuery } from "react-responsive";
import NavigationComponent from "../../all-patient/layouts/NavigationComponent";
import PatientDetailsCardSm from "../../all-patient/components/PatientDetailsCardSm";
import PatientInfo from "./PatientInfo";
import PatientDetailsComponent from "../../all-patient/layouts/PatientDetailsComponent";
import Records from "../../all-patient/pages/Records";
import { useUserItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { useCurrentRole } from "../../_helper/constant/Permission";
import ConsultationMain from "./ConsultationMain";
import Popup from "reactjs-popup";
import PatientSummary from "../../patient_information/views/PatientSummary";

export const lefbarOptions = [
  // {
  //   id: 1,
  //   label: "Summary",
  //   icon: CONSULTATION_ICONS.first,
  //   class: "cu-summary",
  // },
  {
    id: 1,
    label: "Profile",
    icon: CONSULTATION_ICONS.second,
    class: "cu-profile",
  },
  {
    id: 2,
    label: "Health Board",
    icon: CONSULTATION_ICONS.third,
    class: "cu-health-board",
  },
  // {
  //   id: 4,
  //   label: "Message",
  //   icon: CONSULTATION_ICONS.fourth,
  //   class: "cu-message",
  // },
  // {
  //   id: 5,
  //   label: "CuConnect",
  //   icon: CONSULTATION_ICONS.fifth,
  //   class: "cu-connect",
  // },
  // {
  //   id: 6,
  //   label: "My Care Team",
  //   icon: CONSULTATION_ICONS.sixth,
  //   class: "cu-my-care-team",
  // },
  // {
  //   id: 7,
  //   label: "My Goals",
  //   icon: CONSULTATION_ICONS.seven,
  //   class: "cu-my-goals",
  // },
  // {
  //   id: 8,
  //   label: "Notes",
  //   icon: CONSULTATION_ICONS.eaight,
  //   class: "cu-notes",
  // },
  // {
  //   id: 9,
  //   label: "Referrals",
  //   icon: CONSULTATION_ICONS.nine,
  //   class: "cu-referrals",
  // },
  // {
  //   id: 10,
  //   label: "Forms",
  //   icon: CONSULTATION_ICONS.ten,
  //   class: "cu-forms",
  // },
  // {
  //   id: 11,
  //   label: "Notification",
  //   icon: CONSULTATION_ICONS.eleven,
  //   class: "cu-notification",
  // },
  // {
  //   id: 12,
  //   label: "Settings",
  //   icon: CONSULTATION_ICONS.twelve,
  //   class: "cu-settings",
  // },
];

const ConsultationLeftBar = () => {
  const sm = useMediaQuery({ query: "(max-width:635px)" });
  const ongoingConsultation = JSON.parse(
    localStorage.getItem("ongoing_consultations")
  );
  const [isExpanded, setIsExpanded] = useState(false);
  const [clinic] = useAtom(clinicAtom);
  const { role_id } = useCurrentRole();
  // const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const option = searchParams.get("option");
  const allClinic = searchParams.get("all_clinic");
  const userId = searchParams.get("userId");
  const clinicIds = allClinic === "true" ? "" : `&clinic_ids=${clinic?.id}`;
  const filter = `?action=getDoctorPatients&backend=True&clinic_id=${clinic?.id}&doctor_id=${role_id}${clinicIds}&id=${userId}`;

  const { data, isLoading } = useUserItemsFilter(
    ApiEndPoint.USERS,
    filter,
    clinic && role_id && userId ? true : false
  );

  const [patientData, setPatientData] = useState([]);

  useEffect(() => {
    if (data) {
      // setPatientData(data[0]);
      setPatientData(data);
    }
  }, [data]);

  const [lefbarData, setLeftbarData] = useState(
    ongoingConsultation?.length > 0
      ? [
          {
            id: 13,
            label: "Ongoing Consultation",
            icon: <BsFileEarmarkMedical size={"20px"} />,
            class: "cu-settings",
            path: ongoingConsultation[0],
          },
          ...lefbarOptions,
        ]
      : lefbarOptions
  );

  // const addQueryParam = (key, value) => {
  //   // const searchParams = new URLSearchParams(location.search);
  //   searchParams.set(key, value);
  //   navigate({
  //     pathname: location.pathname,
  //     search: searchParams.toString(),
  //   });
  // };

  const handleItemClick = (item) => {
    if (item?.label === "Ongoing Consultation") {
      navigate(`${item?.path}&all_clinic=${allClinic || false}`);
    } else {
      // const newUrl = `/new/all-patient/${userId}?option=${removeSpacesAndConvertToLower(
      //   item.label
      // )}&all_clinic=${allClinic || false}&userId=${userId}`;
      // navigate(newUrl);
      navigate(
        `/new/patient-options?${item?.label === "Health Board" && "&option-tab=appointments"}&option=${removeSpacesAndConvertToLower(
          item.label
        )}&all_clinic=${allClinic || false}&userId=${userId}`
      );
    }
  };

  const removeSpacesAndConvertToLower = (input) => {
    if (input?.length > 0) {
      return input.replace(/\s+/g, "").toLowerCase();
    }
  };

  // //("option-0000-------", option);

  return !sm ? (
    <>
      <PatientInfo
        name={patientData?.full_name}
        dob={patientData?.dob}
        gender={patientData?.gender}
        phone={patientData?.phone}
        email={patientData?.email}
        profile_image={patientData?.profile_image}
        isFavorite={patientData?.special_patient}
      />
      <div className="flex">
        <div
          className={`cu-consultation-lefbar-container ${
            isExpanded ? "cu-consultation-lefbar-container-expand" : ""
          }`}
        >
          {lefbarData?.map((ele, idx) => (
            <div
              key={ele.id}
              className={`cu-consultation-leftbar-item ${
                option === removeSpacesAndConvertToLower(ele?.label)
                  ? "cu-consultation-leftbar-item-active"
                  : ""
              } ${isExpanded ? "cu-consultation-leftbar-item-expand" : ""}`}
              style={{ borderTop: "0.56px solid #cccccc" }}
              onClick={() => handleItemClick(ele)}
            >
              {/* {ele?.label === "Ongoing Consultation" ? (
                !isExpanded ? (
                  <Popup
                    inverted
                    position={"right center"}
                    content={ele?.label}
                    trigger={ele?.icon}
                  />
                ) : (
                  ele?.icon
                )
              ) : // ele?.icon
              !isExpanded ? (
                <Popup
                  inverted
                  position={"right center"}
                  content={ele?.label}
                  trigger={<img src={ele?.icon} className={ele?.class} />}
                />
              ) : (
                <img src={ele?.icon} className={ele?.class} />
              )} */}
              {ele?.label === "Ongoing Consultation" ? (
                !isExpanded ? (
                  <Popup
                    trigger={ele?.icon}
                    position="right center"
                    on="hover"
                    closeOnDocumentClick
                    contentStyle={{
                      padding: "10px 5px",
                      border: "none",
                      width: "fit-content",
                    }}
                    arrow={true}
                  >
                    <div>{ele?.label}</div>
                  </Popup>
                ) : (
                  ele?.icon
                )
              ) : // ele?.icon
              !isExpanded ? (
                <Popup
                  trigger={<img src={ele?.icon} className={ele?.class} />}
                  position="right center"
                  on="hover"
                  closeOnDocumentClick
                  contentStyle={{
                    padding: "10px 5px",
                    border: "none",
                    width: "fit-content",
                    backgroundColor: "black",
                    color: "white",
                  }}
                  arrowStyle={{ color: "black" }}
                  arrow={true}
                >
                  <div>{ele?.label}</div>
                </Popup>
              ) : (
                <img src={ele?.icon} className={ele?.class} />
              )}

              {isExpanded && <span>{ele.label}</span>}
            </div>
          ))}
          <img
            src={CONSULTATION_ICONS.sidebarExpand}
            className={`cu-consultation-leftbar-expand-btn z-20  ${
              !isExpanded ? "rotate-180" : ""
            }`}
            style={{ right: "-20px" }}
            onClick={() => setIsExpanded(!isExpanded)}
          />
        </div>
        {option === "summary" && <PatientSummary />}
        {option === "profile" && <PatientDetailsComponent />}
        {option === "healthboard" && <Records />}
        {option === "ongoingconsultation" && <ConsultationMain />}
      </div>
    </>
  ) : (
    <>
      {option !== "ongoingconsultation" && (
        <PatientDetailsCardSm isFavorite={patientData?.special_patient} />
      )}
      {!option && (
        <NavigationComponent
          lefbarData={lefbarData}
          handleItemClick={handleItemClick}
        />
      )}
      {option === "profile" && <PatientDetailsComponent />}
      {option === "healthboard" && <Records />}
      {option === "ongoingconsultation" && <ConsultationMain />}
    </>
  );
};

export default ConsultationLeftBar;
